module.exports = __webpack_public_path__ + "static/media/icone_oeuvreprotestante.aae26415.svg";